import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";


export const StationLocationClientManager = (function() {

	var restUrl = LS2PAC_CONSTANTS.restUrls.stationLocation;

	const getCurrentBranchEvent = LS2PAC_CONSTANTS.Events.onGetCurrentBranch;

	TLCEventManager.addListener(getCurrentBranchEvent, function() {
		onGetCurrentBranch();
	});

	var onGetCurrentBranch = function() {
		TLCRest.jsonCall(restUrl, {
			dataType: "text",
			callback: function(text) {
				const data = text ? JSON.parse(text) : null;
				TLCLogger.log("onGetCurrentBranch", data);
				TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetCurrentBranchResponse, {success: true, branch: data});
			},
			error: function() {
				TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetCurrentBranchResponse, {success: false});
			},
            cache: false
		});
	};

	return {
		getCurrentBranchEvent: getCurrentBranchEvent
	};

})();
